import React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import { TablePagination } from 'react-pagination-table';

import Download from './Download';

import Snackbar from '../../../labels/Snackbar';

class ListValues extends React.Component {
    state = {
        error: undefined,
        report_lot: this.props.report_lot,
        data:
            this.props.report_lot && this.props.report_lot.values
                ? this.props.report_lot.values
                : [],
    };

    static getDerivedStateFromProps(props, state) {
        const { report_lot } = props;
        if (report_lot !== state.report_lot) {
            state.report_lot = report_lot;
            state.data = report_lot ? report_lot.values : [];
            return state;
        }
        return null;
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    render() {
        const { error, data, report_lot } = this.state;
        const { intl } = this.props;

        const Header = [
            intl.formatMessage({ id: 'instance' }),
            intl.formatMessage({ id: 'local' }),
            intl.formatMessage({ id: 'date' }),
            intl.formatMessage({ id: 'value' }),
        ];

        console.log(data);
        return (
            <div className={'flex_full_column height100 padding_borders'}>
                <div className={'flex_auto_row showbar overflow_y_scroll'} onScroll={this.handleScroll}>
                    <TablePagination
                        headers={Header}
                        data={data ? data : []}
                        columns="id.local.fecha.valor"
                        arrayOption={[['size', 'all', ' ']]}
                        className="table_search"
                    />
                </div>
                <Download {...this.props} info={data} parameters={[report_lot]} />
                {error && (
                    <Snackbar
                        open={true}
                        variant="error"
                        text={error}
                        onClose={this.handleCloseError.bind(this)}
                    />
                )}
            </div>
        );
    }
}

ListValues.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(ListValues);



// WEBPACK FOOTER //
// ./src/components/complex/reports/lot/List.js